/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PairRfidPayload } from 'api/actions/pair-rfid/pair-rfid-payload';
import { PairRfidPathParameters } from 'api/actions/pair-rfid/pair-rfid-path-parameters';
import { PairRfidResponse } from 'api/actions/pair-rfid/pair-rfid-response';

type PairRfidQueryParameters = Record<string, any>;

/**
 * The path of the PairRfid action.
 */
export const pairRfidActionPath = new SweetPath<keyof PairRfidPathParameters>('/rfid/pair', { path: '{param}' });

/**
 * Creates a contextualized PairRfid actions.
 */
export default function createPairRfidAction(axios: AxiosInstance) {
  return function pairRfidAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: PairRfidQueryParameters;
    payload: PairRfidPayload;
  }) {
    const path = pairRfidActionPath.original;

    return axios.post<PairRfidResponse, PairRfidResponse, PairRfidPayload>(path, payload);
  };
}
